export enum AiFormFieldsNames {
  AiPrompt = 'aiPrompt',
}
export interface AiFormFields {
  [AiFormFieldsNames.AiPrompt]: string;
}
